import * as React from 'react';
import { useContext } from 'react';
import { System } from '../core/System';

export const SystemContext = React.createContext<System>(null);

export const useSystem = () => {
  return useContext(SystemContext);
};
